module.exports = __webpack_public_path__ + "img/67_21.f376fe94.png";